import { create } from 'zustand';

/**
 * 撤销动作栈：既收"我画的笔画"也收"我发起的擦除事件"，Ctrl+Z 时按最新
 * 动作分发（擦笔画 / 撤销擦除）。放在全局 store 而不是 useDrawing 里，
 * 因为管理员区域擦除（REST）也要往栈里推动作。
 */
export type UndoAction =
  | { kind: 'stroke'; id: number }
  | { kind: 'erase'; evId: number };

interface UndoState {
  stack: UndoAction[];
  push: (a: UndoAction) => void;
  pop: () => UndoAction | undefined;
  /** 别人擦掉了我的笔画后，这些笔画的撤销动作作废 */
  pruneStrokes: (ids: number[]) => void;
  clear: () => void;
}

export const useUndo = create<UndoState>((set) => ({
  stack: [],
  push: (a) => set((s) => ({ stack: [...s.stack, a] })),
  pop: (): UndoAction | undefined => {
    let popped: UndoAction | undefined;
    set((s) => {
      if (s.stack.length === 0) return s;
      popped = s.stack[s.stack.length - 1];
      return { stack: s.stack.slice(0, -1) };
    });
    return popped;
  },
  pruneStrokes: (ids) =>
    set((s) => {
      const dead = new Set(ids);
      const next = s.stack.filter((a) => !(a.kind === 'stroke' && dead.has(a.id)));
      return next.length === s.stack.length ? s : { stack: next };
    }),
  clear: () => set({ stack: [] }),
}));
